import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "checkout" }
const _hoisted_2 = { class: "grid place-items-center my-28 xl:mb-14" }
const _hoisted_3 = { class: "px-4 w-full max-w-xl" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg text-primary" }, "Shipping Address", -1)
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg text-primary" }, "Summary", -1)
const _hoisted_10 = { class: "mt-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "mt-6" }
const _hoisted_13 = { class: "flex justify-between my-3 text-primary" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg" }, "Total", -1)
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "inline-block p-2.5 px-8 text-white uppercase outline-none bg-primary",
    type: "submit"
  }, " Place Order ")
], -1)

import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";

import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

import router from "@/router";
import { OrderApi } from "@/api/order";
import { IProduct } from "@/interfaces/IProduct";
import { loadingWrapper } from "@/helpers/loading-wrapper";
import { ProductComponent, ShippingInformation } from "@/interfaces/IOrder";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const form = ref(null);

const shippingInformationDefault: ShippingInformation = {
  customerName: "",
  phoneNumber: "",
  address: "",
  notes: "",
};

const shippingInformation = ref<ShippingInformation>({
  ...shippingInformationDefault,
});

const shoppingCartList = computed(() => store.state.shoppingCartList);
const checkoutProducts = computed(() =>
  shoppingCartList.value.map(
    (e: IProduct) =>
      new ProductComponent({
        product: e.id,
        quantity: e.quantity,
        subTotal: e.quantity * e.price,
      })
  )
);

const subtotal = (price: number, quantity: number) => {
  return price * quantity;
};

const totalPrice = computed(() =>
  shoppingCartList.value
    .map((e: IProduct) => e.price * e.quantity)
    .reduce((a: number, b: number) => a + b, 0)
);

const handlePlaceOrder = async () => {
  await OrderApi.createOrder({
    customerName: shippingInformation.value.customerName,
    phoneNumber: shippingInformation.value.phoneNumber,
    address: shippingInformation.value.address,
    notes: shippingInformation.value.notes,
    total: totalPrice.value,
    products: checkoutProducts.value,
  });

  Swal.fire({
    icon: "success",
    title: "Success",
    text: "Order has been placed successfully",
    confirmButtonColor: "#0c97ad",
  });

  shippingInformation.value = { ...shippingInformationDefault };
  store.dispatch("resetShoppingCartList");
  router.push("/");
};

onMounted(async () => {
  loadingWrapper();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          ref_key: "form",
          ref: form,
          onSubmit: _withModifiers(handlePlaceOrder, ["prevent"])
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shippingInformation.value.customerName) = $event)),
              type: "text",
              class: "block my-4 w-full rounded-sm border-gray-400 shadow-sm sm:text-sm focus:ring-primary focus:border-primary",
              placeholder: "Name",
              required: ""
            }, null, 512), [
              [_vModelText, shippingInformation.value.customerName]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shippingInformation.value.phoneNumber) = $event)),
              type: "text",
              class: "block my-4 w-full rounded-sm border-gray-400 shadow-sm sm:text-sm focus:ring-primary focus:border-primary",
              placeholder: "Phone Number",
              required: ""
            }, null, 512), [
              [_vModelText, shippingInformation.value.phoneNumber]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shippingInformation.value.address) = $event)),
              type: "text",
              class: "block my-4 w-full rounded-sm border-gray-400 shadow-sm sm:text-sm focus:ring-primary focus:border-primary",
              placeholder: "Address",
              required: ""
            }, null, 512), [
              [_vModelText, shippingInformation.value.address]
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shippingInformation.value.notes) = $event)),
              class: "block my-4 w-full rounded-sm border-gray-400 shadow-sm sm:text-sm focus:ring-primary focus:border-primary",
              placeholder: "Notes"
            }, null, 512), [
              [_vModelText, shippingInformation.value.notes]
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shoppingCartList), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "flex justify-between my-3"
                }, [
                  _createElementVNode("div", null, _toDisplayString(item.name) + " (" + _toDisplayString(item.quantity) + ")", 1),
                  _createElementVNode("div", null, "$ " + _toDisplayString(subtotal(item.quantity, item.price)), 1)
                ]))
              }), 128))
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, "$ " + _toDisplayString(_unref(totalPrice)), 1)
            ])
          ]),
          _hoisted_16
        ], 40, _hoisted_4)
      ])
    ])
  ]))
}
}

})